<template>
    <v-speed-dial
            v-model="fab"
            fixed
            bottom
            right
            direction="left"
            transition="slide-x-reverse-transition"
    >
        <template v-slot:activator>
            <v-btn
                    v-model="fab"
                    color="primary"
                    dark
                    fab
            >
                <v-icon>fa-plus</v-icon>
                <v-icon>fa-times</v-icon>
            </v-btn>
        </template>
        <v-btn
                v-for="(btn, i) in items"
                :key="i"
                fab
                dark
                small
                :color="btn.color || 'primary'"
                @click="$emit('click:btn', btn.id)"
        >
            <v-icon>{{btn.icon}}</v-icon>
        </v-btn>
    </v-speed-dial>
</template>

<script>
    export default{
        props: ['items'],
        data(){
            return {
                fab: false
            }
        }
    }
</script>